import { PostgrestResponse, SupabaseClient } from '@supabase/supabase-js';
import { VideoMarkerDto, VideoMarkerInsertDto } from 'modules/core/domain/interfaces/supabase/video-markers/dto';

const table = 'video_markers';

/**
 * Видеометки событий матча и опорные точки хронометража (IMGM-1484).
 *
 * Оверлей только вставляет и читает: политики RLS таблицы не дают клиенту ни править, ни
 * удалять строки.
 */
export default class VideoMarkers {
  constructor(private supabase: SupabaseClient) {}

  /**
   * Вставить метку; метка того же события той же программы молча пропускается
   * (`ON CONFLICT DO NOTHING`), чтобы перезагрузка оверлея не дублировала её. Строку назад не
   * запрашиваем: на пропущенный дубль `DO NOTHING` ничего не возвращает, и `.single()` упал бы.
   */
  async upsert(row: VideoMarkerInsertDto): Promise<void> {
    const { error } = await this.supabase
      .from(table)
      .upsert(row, { onConflict: 'match_id,event_id,recorder', ignoreDuplicates: true });

    if (error) throw error;
  }

  /** Все строки матча — и метки, и опорные точки — в порядке появления. */
  async listByMatch(matchId: number): Promise<VideoMarkerDto[]> {
    const { data, error } = (await this.supabase
      .from(table)
      .select('*')
      .eq('match_id', matchId)
      .order('client_received_at', { ascending: true })) as PostgrestResponse<VideoMarkerDto>;

    if (error) throw error;

    return data ?? [];
  }
}
